export default __webpack_public_path__ + "static/media/corporates.e1158d38.svg";